import { APP_CONSTANTS } from '../constants/app_constant';
import { HttpMethod } from '../types/global';
import { useAuthStore } from '@/state/useAuthStore';

interface ApiRequestOptions {
    API: string | null;
    DATA?: Record<string, any>;
    METHOD?: HttpMethod;
    ACCESS_TOKEN_REQUIRED?: boolean;
    FORM_DATA?: boolean;
}

// ── auth helpers ──────────────────────────────────────────────────────────────

export const setAuthCredentials = (token: string) => {
    useAuthStore.getState().setToken(token);
};

export const removeAuthCredentials = () => {
    useAuthStore.getState().clearAuth();
};

export const isAuthenticatedFun = (): boolean => {
    return useAuthStore.getState().isAuthenticated();
};

// ── api request ───────────────────────────────────────────────────────────────

export const apiRequest = async ({
    API = null,
    DATA = {},
    METHOD = "POST",
    ACCESS_TOKEN_REQUIRED = true,
    FORM_DATA = false,
}: ApiRequestOptions) => {
    try {
        if (!API) throw new Error("API Endpoint not provided.");

        let ACCESS_TOKEN = null;
        if (ACCESS_TOKEN_REQUIRED) {
            ACCESS_TOKEN = useAuthStore.getState().token;
            if (!ACCESS_TOKEN) {
                throw new Error("Access token not found. Please login.");
            }
        }

        const headers: Record<string, string> = {
            'x-device': 'web',
            'Accept': 'application/json',
            'x-app-from': APP_CONSTANTS.APP_FROM,
        };

        if (ACCESS_TOKEN) {
            headers["Authorization"] = `Bearer ${ACCESS_TOKEN}`;
        }
        if (!FORM_DATA) {
            headers["Content-Type"] = "application/json";
        }

        const options: RequestInit = {
            method: METHOD,
            headers,
        };

        if (METHOD !== "GET") {
            if (FORM_DATA) {
                options.body = DATA as FormData;
            } else {
                if (DATA && typeof DATA === "object" && !Array.isArray(DATA)) {
                    options.body = JSON.stringify(DATA);
                } else {
                    throw new Error("Invalid DATA format. Expected an object.");
                }
            }
        } else if (DATA && Object.keys(DATA).length > 0) {
            const queryParams = new URLSearchParams(DATA).toString();
            API = `${API}?${queryParams}`;
        }

        const response = await fetch(`${APP_CONSTANTS.API_BASE_URL}${API}`, options);

        let data;
        try {
            data = await response.json();
        } catch {
            throw new Error("Invalid JSON response from API");
        }

        if (!response.ok) {
            throw { ...data, status: response.status };
        }

        return data;
    } catch (error: any) {
        console.log(error);
        throw error;
    }
};